export default "__VITE_ASSET__DqN5ReK4__"